import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { renderLocationChoice } from '../../../common/components/SearchHeader/types/LocationChoice';
import { SidebarLinkSection } from '../../ResultView/Sidebar/SidebarLinkSection/SidebarLinkSection';
import { composeFilters } from '../../page-seo/composeFilters';
import { makeLinkSpec } from '../../page-seo/makeLinkSpec';
import { LinkSection } from '../LinkSection/LinkSection';
import { makeInterestPreset, makeProcedurePreset } from './helpers';

interface Props {
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const TreatmentPresetLinks = ({ filters, isSidebar = false }: Props) => {
  const commonLinkSectionProps = {
    title: `Find practices by treatment in ${renderLocationChoice(filters.location)}`,
    links: getLinksBySpecialty(filters.topic?.specialist).map(preset =>
      makeLinkSpec(composeFilters(filters, preset.filters), preset.title),
    ),
  };

  const linkSection = isSidebar ? (
    <SidebarLinkSection {...commonLinkSectionProps} />
  ) : (
    <LinkSection {...commonLinkSectionProps} />
  );

  return !filters.onlineAppointments ? linkSection : null;
};

const getLinksBySpecialty = (specialtyName?: string) => {
  if (specialtyName === 'Dentist') {
    return [
      makeInterestPreset('Check Ups', 'Dental Check Ups'),
      makeInterestPreset('Dental Hygiene', 'Hygiene/Cleans'),
      makeProcedurePreset('Teeth Whitening'),
      makeProcedurePreset('Dental Implants'),
      makeInterestPreset('Root Canal Treatments', 'Root Canal'),
      makeInterestPreset('Fillings'),
      makeProcedurePreset('Crown and Bridge', 'Crowns'),
      makeProcedurePreset('Crown and Bridge', 'Bridges'),
      makeInterestPreset('Invisalign'),
      makeInterestPreset('Braces'),
      makeProcedurePreset('Veneers'),
      makeInterestPreset('Orthodontics'),
      makeInterestPreset('Wisdom Teeth Removal'),
    ];
  }

  if (specialtyName === 'Physiotherapist') {
    return [
      makeInterestPreset('Dry Needle Therapy'),
      makeInterestPreset('Massage Therapy'),
      makeInterestPreset('Post Surgical Rehabilitation'),
      makeInterestPreset('Rehabilitative Exercises', 'Rehabilitation Exercises'),
      makeInterestPreset('Remedial Massage'),
      makeInterestPreset('Sports Rehabilitation'),
      makeInterestPreset('Pilates'),
      makeInterestPreset('Acupuncture'),
      makeInterestPreset('Hydrotherapy'),
      makeInterestPreset('Personal Training'),
      makeInterestPreset('Spinal Adjustment'),
      makeInterestPreset('Deep Tissue Massage'),
      makeInterestPreset('Trigger Point Therapy'),
      makeInterestPreset('Manual Manipulation'),
    ];
  }

  if (specialtyName === 'General Practice' || specialtyName === 'GP') {
    return [
      makeInterestPreset("Men's Health", "Men's Health"),
      makeInterestPreset("Women's Health", "Women's Health"),
      makeInterestPreset("Children's health", "Children's health"),
      makeInterestPreset('Family medicine', 'Family medicine'),
      makeInterestPreset('Flu vaccinations', 'Flu vaccinations'),
      makeInterestPreset('Skin checks', 'Skin checks'),
      makeInterestPreset('Immunisation and Vaccination', 'Immunisation & Vaccination'),
      makeInterestPreset('Shared Antenatal Care', 'Shared Antenatal Care'),
      makeInterestPreset('Minor Surgery', 'Minor Surgery'),
      makeInterestPreset('Mental health', 'Mental health'),
      makeInterestPreset('Travel medicine', 'Travel medicine'),
    ];
  }

  return [];
};
